import React from 'react';
import useAppDataInitialization from '../hooks/useAppDataInitialization';

const AppDataInitializer = (props) => {
    useAppDataInitialization(props);
    return null;
};

export default AppDataInitializer;
